// Generated from contract/currencies.json by pnpm gen. Do not edit.

export const CurrencyCode = {
  AED: "AED",
  AFN: "AFN",
  ALL: "ALL",
  AMD: "AMD",
  ANG: "ANG",
  AOA: "AOA",
  ARS: "ARS",
  AUD: "AUD",
  AWG: "AWG",
  AZN: "AZN",
  BAM: "BAM",
  BBD: "BBD",
  BDT: "BDT",
  BHD: "BHD",
  BIF: "BIF",
  BMD: "BMD",
  BND: "BND",
  BOB: "BOB",
  BRL: "BRL",
  BSD: "BSD",
  BTN: "BTN",
  BWP: "BWP",
  BYN: "BYN",
  BZD: "BZD",
  CAD: "CAD",
  CDF: "CDF",
  CHF: "CHF",
  CLP: "CLP",
  CMD: "CMD",
  CNH: "CNH",
  CNY: "CNY",
  COP: "COP",
  CRC: "CRC",
  CUP: "CUP",
  CVE: "CVE",
  CZK: "CZK",
  DJF: "DJF",
  DKK: "DKK",
  DOP: "DOP",
  DZD: "DZD",
  EGP: "EGP",
  ERN: "ERN",
  ETB: "ETB",
  EUR: "EUR",
  FJD: "FJD",
  FKP: "FKP",
  GBP: "GBP",
  GEL: "GEL",
  GGP: "GGP",
  GHS: "GHS",
  GIP: "GIP",
  GMD: "GMD",
  GNF: "GNF",
  GTQ: "GTQ",
  GYD: "GYD",
  HKD: "HKD",
  HNL: "HNL",
  HTG: "HTG",
  HUF: "HUF",
  IDR: "IDR",
  ILS: "ILS",
  IMP: "IMP",
  INR: "INR",
  IQD: "IQD",
  IRR: "IRR",
  ISK: "ISK",
  JEP: "JEP",
  JMD: "JMD",
  JOD: "JOD",
  JPY: "JPY",
  KES: "KES",
  KGS: "KGS",
  KHR: "KHR",
  KMF: "KMF",
  KPW: "KPW",
  KRW: "KRW",
  KWD: "KWD",
  KYD: "KYD",
  KZT: "KZT",
  LAK: "LAK",
  LBP: "LBP",
  LKR: "LKR",
  LRD: "LRD",
  LSL: "LSL",
  LYD: "LYD",
  MAD: "MAD",
  MDL: "MDL",
  MGA: "MGA",
  MKD: "MKD",
  MMK: "MMK",
  MNT: "MNT",
  MOP: "MOP",
  MRU: "MRU",
  MUR: "MUR",
  MVR: "MVR",
  MWK: "MWK",
  MXN: "MXN",
  MYR: "MYR",
  MZN: "MZN",
  NAD: "NAD",
  NGN: "NGN",
  NIO: "NIO",
  NOK: "NOK",
  NPR: "NPR",
  NZD: "NZD",
  OMR: "OMR",
  PAB: "PAB",
  PEN: "PEN",
  PGK: "PGK",
  PHP: "PHP",
  PKR: "PKR",
  PLN: "PLN",
  PYG: "PYG",
  QAR: "QAR",
  RON: "RON",
  RSD: "RSD",
  RUB: "RUB",
  RWF: "RWF",
  SAR: "SAR",
  SBD: "SBD",
  SCR: "SCR",
  SDG: "SDG",
  SEK: "SEK",
  SGD: "SGD",
  SHP: "SHP",
  SLE: "SLE",
  SOS: "SOS",
  SRD: "SRD",
  SSP: "SSP",
  STN: "STN",
  SVC: "SVC",
  SYP: "SYP",
  SZL: "SZL",
  THB: "THB",
  TJS: "TJS",
  TMT: "TMT",
  TND: "TND",
  TOP: "TOP",
  TRY: "TRY",
  TTD: "TTD",
  TWD: "TWD",
  TZS: "TZS",
  UAH: "UAH",
  UGX: "UGX",
  USD: "USD",
  UYU: "UYU",
  UZS: "UZS",
  VES: "VES",
  VND: "VND",
  VUV: "VUV",
  WST: "WST",
  XAF: "XAF",
  XAG: "XAG",
  XAU: "XAU",
  XCD: "XCD",
  XCG: "XCG",
  XDR: "XDR",
  XOF: "XOF",
  XPD: "XPD",
  XPF: "XPF",
  XPT: "XPT",
  YER: "YER",
  ZAR: "ZAR",
  ZMW: "ZMW",
  ZWG: "ZWG",
} as const

export type CurrencyCode = (typeof CurrencyCode)[keyof typeof CurrencyCode]

export type SymbolPosition = 'before' | 'after'

export interface CurrencyMetadata {
  readonly code: CurrencyCode
  readonly name: string
  readonly isoFractionDigits: number | null
  readonly displayFractionDigits: number
  readonly symbol: string
  readonly symbolPosition: SymbolPosition
}

export const CURRENCIES: Readonly<Record<CurrencyCode, CurrencyMetadata>> = {
  AED: { code: "AED", name: "United Arab Emirates Dirham", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "د.إ", symbolPosition: "before" },
  AFN: { code: "AFN", name: "Afghan Afghani", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "؋", symbolPosition: "before" },
  ALL: { code: "ALL", name: "Albanian Lek", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "L", symbolPosition: "after" },
  AMD: { code: "AMD", name: "Armenian Dram", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "֏", symbolPosition: "before" },
  ANG: { code: "ANG", name: "Netherlands Antillean Guilder", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "ƒ", symbolPosition: "before" },
  AOA: { code: "AOA", name: "Angolan Kwanza", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Kz", symbolPosition: "before" },
  ARS: { code: "ARS", name: "Argentine Peso", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  AUD: { code: "AUD", name: "Australian Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  AWG: { code: "AWG", name: "Aruban Florin", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "ƒ", symbolPosition: "before" },
  AZN: { code: "AZN", name: "Azerbaijani Manat", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₼", symbolPosition: "before" },
  BAM: { code: "BAM", name: "Bosnia and Herzegovina Convertible Mark", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "КМ", symbolPosition: "after" },
  BBD: { code: "BBD", name: "Barbadian Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  BDT: { code: "BDT", name: "Bangladeshi Taka", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "৳", symbolPosition: "before" },
  BHD: { code: "BHD", name: "Bahraini Dinar", isoFractionDigits: 3, displayFractionDigits: 3, symbol: "د.ب", symbolPosition: "before" },
  BIF: { code: "BIF", name: "Burundian Franc", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "Fr", symbolPosition: "before" },
  BMD: { code: "BMD", name: "Bermudian Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  BND: { code: "BND", name: "Brunei Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  BOB: { code: "BOB", name: "Bolivian Boliviano", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Bs.", symbolPosition: "before" },
  BRL: { code: "BRL", name: "Brazilian Real", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "R$", symbolPosition: "before" },
  BSD: { code: "BSD", name: "Bahamian Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  BTN: { code: "BTN", name: "Bhutanese Ngultrum", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Nu.", symbolPosition: "before" },
  BWP: { code: "BWP", name: "Botswana Pula", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "P", symbolPosition: "before" },
  BYN: { code: "BYN", name: "Belarusian Ruble", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Br", symbolPosition: "after" },
  BZD: { code: "BZD", name: "Belize Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  CAD: { code: "CAD", name: "Canadian Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  CDF: { code: "CDF", name: "Congolese Franc", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Fr", symbolPosition: "before" },
  CHF: { code: "CHF", name: "Swiss Franc", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "CHF", symbolPosition: "before" },
  CLP: { code: "CLP", name: "Chilean Peso", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "$", symbolPosition: "before" },
  CMD: { code: "CMD", name: "COMESA Dollar", isoFractionDigits: null, displayFractionDigits: 2, symbol: "CMD", symbolPosition: "before" },
  CNH: { code: "CNH", name: "Chinese Renminbi Yuan Offshore", isoFractionDigits: null, displayFractionDigits: 2, symbol: "¥", symbolPosition: "before" },
  CNY: { code: "CNY", name: "Chinese Renminbi Yuan", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "¥", symbolPosition: "before" },
  COP: { code: "COP", name: "Colombian Peso", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  CRC: { code: "CRC", name: "Costa Rican Colón", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₡", symbolPosition: "before" },
  CUP: { code: "CUP", name: "Cuban Peso", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  CVE: { code: "CVE", name: "Cape Verdean Escudo", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  CZK: { code: "CZK", name: "Czech Koruna", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Kč", symbolPosition: "after" },
  DJF: { code: "DJF", name: "Djiboutian Franc", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "Fdj", symbolPosition: "before" },
  DKK: { code: "DKK", name: "Danish Krone", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "kr.", symbolPosition: "after" },
  DOP: { code: "DOP", name: "Dominican Peso", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  DZD: { code: "DZD", name: "Algerian Dinar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "د.ج", symbolPosition: "before" },
  EGP: { code: "EGP", name: "Egyptian Pound", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "ج.م", symbolPosition: "before" },
  ERN: { code: "ERN", name: "Eritrean Nakfa", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Nfk", symbolPosition: "before" },
  ETB: { code: "ETB", name: "Ethiopian Birr", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Br", symbolPosition: "before" },
  EUR: { code: "EUR", name: "Euro", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "€", symbolPosition: "after" },
  FJD: { code: "FJD", name: "Fijian Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  FKP: { code: "FKP", name: "Falkland Pound", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "£", symbolPosition: "before" },
  GBP: { code: "GBP", name: "British Pound", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "£", symbolPosition: "before" },
  GEL: { code: "GEL", name: "Georgian Lari", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₾", symbolPosition: "before" },
  GGP: { code: "GGP", name: "Guernsey Pound", isoFractionDigits: null, displayFractionDigits: 2, symbol: "£", symbolPosition: "before" },
  GHS: { code: "GHS", name: "Ghanaian Cedi", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₵", symbolPosition: "before" },
  GIP: { code: "GIP", name: "Gibraltar Pound", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "£", symbolPosition: "before" },
  GMD: { code: "GMD", name: "Gambian Dalasi", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "D", symbolPosition: "before" },
  GNF: { code: "GNF", name: "Guinean Franc", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "Fr", symbolPosition: "before" },
  GTQ: { code: "GTQ", name: "Guatemalan Quetzal", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Q", symbolPosition: "before" },
  GYD: { code: "GYD", name: "Guyanese Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  HKD: { code: "HKD", name: "Hong Kong Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  HNL: { code: "HNL", name: "Honduran Lempira", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "L", symbolPosition: "before" },
  HTG: { code: "HTG", name: "Haitian Gourde", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "G", symbolPosition: "before" },
  HUF: { code: "HUF", name: "Hungarian Forint", isoFractionDigits: 2, displayFractionDigits: 0, symbol: "Ft", symbolPosition: "after" },
  IDR: { code: "IDR", name: "Indonesian Rupiah", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Rp", symbolPosition: "before" },
  ILS: { code: "ILS", name: "Israeli New Shekel", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₪", symbolPosition: "before" },
  IMP: { code: "IMP", name: "Isle of Man Pound", isoFractionDigits: null, displayFractionDigits: 2, symbol: "£", symbolPosition: "before" },
  INR: { code: "INR", name: "Indian Rupee", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₹", symbolPosition: "before" },
  IQD: { code: "IQD", name: "Iraqi Dinar", isoFractionDigits: 3, displayFractionDigits: 3, symbol: "ع.د", symbolPosition: "before" },
  IRR: { code: "IRR", name: "Iranian Rial", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "﷼", symbolPosition: "before" },
  ISK: { code: "ISK", name: "Icelandic Króna", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "kr.", symbolPosition: "after" },
  JEP: { code: "JEP", name: "Jersey Pound", isoFractionDigits: null, displayFractionDigits: 2, symbol: "£", symbolPosition: "before" },
  JMD: { code: "JMD", name: "Jamaican Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  JOD: { code: "JOD", name: "Jordanian Dinar", isoFractionDigits: 3, displayFractionDigits: 3, symbol: "د.ا", symbolPosition: "before" },
  JPY: { code: "JPY", name: "Japanese Yen", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "¥", symbolPosition: "before" },
  KES: { code: "KES", name: "Kenyan Shilling", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "KSh", symbolPosition: "before" },
  KGS: { code: "KGS", name: "Kyrgyzstani Som", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "som", symbolPosition: "before" },
  KHR: { code: "KHR", name: "Cambodian Riel", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "៛", symbolPosition: "before" },
  KMF: { code: "KMF", name: "Comorian Franc", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "Fr", symbolPosition: "before" },
  KPW: { code: "KPW", name: "North Korean Won", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₩", symbolPosition: "before" },
  KRW: { code: "KRW", name: "South Korean Won", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "₩", symbolPosition: "before" },
  KWD: { code: "KWD", name: "Kuwaiti Dinar", isoFractionDigits: 3, displayFractionDigits: 3, symbol: "د.ك", symbolPosition: "before" },
  KYD: { code: "KYD", name: "Cayman Islands Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  KZT: { code: "KZT", name: "Kazakhstani Tenge", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₸", symbolPosition: "before" },
  LAK: { code: "LAK", name: "Lao Kip", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₭", symbolPosition: "before" },
  LBP: { code: "LBP", name: "Lebanese Pound", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "ل.ل", symbolPosition: "before" },
  LKR: { code: "LKR", name: "Sri Lankan Rupee", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₨", symbolPosition: "before" },
  LRD: { code: "LRD", name: "Liberian Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  LSL: { code: "LSL", name: "Lesotho Loti", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "L", symbolPosition: "before" },
  LYD: { code: "LYD", name: "Libyan Dinar", isoFractionDigits: 3, displayFractionDigits: 3, symbol: "ل.د", symbolPosition: "before" },
  MAD: { code: "MAD", name: "Moroccan Dirham", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "د.م.", symbolPosition: "before" },
  MDL: { code: "MDL", name: "Moldovan Leu", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "L", symbolPosition: "after" },
  MGA: { code: "MGA", name: "Malagasy Ariary", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Ar", symbolPosition: "before" },
  MKD: { code: "MKD", name: "Macedonian Denar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "ден", symbolPosition: "after" },
  MMK: { code: "MMK", name: "Myanmar Kyat", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "K", symbolPosition: "before" },
  MNT: { code: "MNT", name: "Mongolian Tögrög", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₮", symbolPosition: "before" },
  MOP: { code: "MOP", name: "Macanese Pataca", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "P", symbolPosition: "before" },
  MRU: { code: "MRU", name: "Mauritanian Ouguiya", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "UM", symbolPosition: "before" },
  MUR: { code: "MUR", name: "Mauritian Rupee", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₨", symbolPosition: "before" },
  MVR: { code: "MVR", name: "Maldivian Rufiyaa", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "MVR", symbolPosition: "before" },
  MWK: { code: "MWK", name: "Malawian Kwacha", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "MK", symbolPosition: "before" },
  MXN: { code: "MXN", name: "Mexican Peso", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  MYR: { code: "MYR", name: "Malaysian Ringgit", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "RM", symbolPosition: "before" },
  MZN: { code: "MZN", name: "Mozambican Metical", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "MTn", symbolPosition: "before" },
  NAD: { code: "NAD", name: "Namibian Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  NGN: { code: "NGN", name: "Nigerian Naira", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₦", symbolPosition: "before" },
  NIO: { code: "NIO", name: "Nicaraguan Córdoba", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "C$", symbolPosition: "before" },
  NOK: { code: "NOK", name: "Norwegian Krone", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "kr", symbolPosition: "after" },
  NPR: { code: "NPR", name: "Nepalese Rupee", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Rs.", symbolPosition: "before" },
  NZD: { code: "NZD", name: "New Zealand Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  OMR: { code: "OMR", name: "Omani Rial", isoFractionDigits: 3, displayFractionDigits: 3, symbol: "ر.ع.", symbolPosition: "before" },
  PAB: { code: "PAB", name: "Panamanian Balboa", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "B/.", symbolPosition: "before" },
  PEN: { code: "PEN", name: "Peruvian Sol", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "S/", symbolPosition: "before" },
  PGK: { code: "PGK", name: "Papua New Guinean Kina", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "K", symbolPosition: "before" },
  PHP: { code: "PHP", name: "Philippine Peso", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₱", symbolPosition: "before" },
  PKR: { code: "PKR", name: "Pakistani Rupee", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₨", symbolPosition: "before" },
  PLN: { code: "PLN", name: "Polish Złoty", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "zł", symbolPosition: "after" },
  PYG: { code: "PYG", name: "Paraguayan Guaraní", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "₲", symbolPosition: "before" },
  QAR: { code: "QAR", name: "Qatari Riyal", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "ر.ق", symbolPosition: "before" },
  RON: { code: "RON", name: "Romanian Leu", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Lei", symbolPosition: "after" },
  RSD: { code: "RSD", name: "Serbian Dinar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "RSD", symbolPosition: "after" },
  RUB: { code: "RUB", name: "Russian Ruble", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₽", symbolPosition: "after" },
  RWF: { code: "RWF", name: "Rwandan Franc", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "FRw", symbolPosition: "before" },
  SAR: { code: "SAR", name: "Saudi Riyal", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "ر.س", symbolPosition: "before" },
  SBD: { code: "SBD", name: "Solomon Islands Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  SCR: { code: "SCR", name: "Seychellois Rupee", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₨", symbolPosition: "before" },
  SDG: { code: "SDG", name: "Sudanese Pound", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "£", symbolPosition: "before" },
  SEK: { code: "SEK", name: "Swedish Krona", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "kr", symbolPosition: "after" },
  SGD: { code: "SGD", name: "Singapore Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  SHP: { code: "SHP", name: "Saint Helenian Pound", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "£", symbolPosition: "before" },
  SLE: { code: "SLE", name: "New Leone", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Le", symbolPosition: "before" },
  SOS: { code: "SOS", name: "Somali Shilling", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Sh", symbolPosition: "before" },
  SRD: { code: "SRD", name: "Surinamese Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  SSP: { code: "SSP", name: "South Sudanese Pound", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "£", symbolPosition: "before" },
  STN: { code: "STN", name: "São Tomé and Príncipe Second Dobra", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Db", symbolPosition: "before" },
  SVC: { code: "SVC", name: "Salvadoran Colón", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₡", symbolPosition: "before" },
  SYP: { code: "SYP", name: "Syrian Pound", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "£S", symbolPosition: "before" },
  SZL: { code: "SZL", name: "Swazi Lilangeni", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "E", symbolPosition: "before" },
  THB: { code: "THB", name: "Thai Baht", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "฿", symbolPosition: "before" },
  TJS: { code: "TJS", name: "Tajikistani Somoni", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "ЅМ", symbolPosition: "before" },
  TMT: { code: "TMT", name: "Turkmenistani Manat", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "m", symbolPosition: "before" },
  TND: { code: "TND", name: "Tunisian Dinar", isoFractionDigits: 3, displayFractionDigits: 3, symbol: "د.ت", symbolPosition: "before" },
  TOP: { code: "TOP", name: "Tongan Paʻanga", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "T$", symbolPosition: "before" },
  TRY: { code: "TRY", name: "Turkish Lira", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₺", symbolPosition: "before" },
  TTD: { code: "TTD", name: "Trinidad and Tobago Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  TWD: { code: "TWD", name: "New Taiwan Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  TZS: { code: "TZS", name: "Tanzanian Shilling", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Sh", symbolPosition: "before" },
  UAH: { code: "UAH", name: "Ukrainian Hryvnia", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "₴", symbolPosition: "after" },
  UGX: { code: "UGX", name: "Ugandan Shilling", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "USh", symbolPosition: "before" },
  USD: { code: "USD", name: "United States Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  UYU: { code: "UYU", name: "Uruguayan Peso", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$U", symbolPosition: "before" },
  UZS: { code: "UZS", name: "Uzbekistan Som", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "so'm", symbolPosition: "before" },
  VES: { code: "VES", name: "Venezuelan Bolívar Soberano", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Bs", symbolPosition: "before" },
  VND: { code: "VND", name: "Vietnamese Đồng", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "₫", symbolPosition: "before" },
  VUV: { code: "VUV", name: "Vanuatu Vatu", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "Vt", symbolPosition: "before" },
  WST: { code: "WST", name: "Samoan Tala", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "T", symbolPosition: "before" },
  XAF: { code: "XAF", name: "Central African CFA Franc", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "CFA", symbolPosition: "before" },
  XAG: { code: "XAG", name: "Silver (Troy Ounce)", isoFractionDigits: null, displayFractionDigits: 2, symbol: "oz t", symbolPosition: "before" },
  XAU: { code: "XAU", name: "Gold (Troy Ounce)", isoFractionDigits: null, displayFractionDigits: 2, symbol: "oz t", symbolPosition: "before" },
  XCD: { code: "XCD", name: "East Caribbean Dollar", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "$", symbolPosition: "before" },
  XCG: { code: "XCG", name: "Caribbean Guilder", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "Cg", symbolPosition: "before" },
  XDR: { code: "XDR", name: "Special Drawing Rights", isoFractionDigits: null, displayFractionDigits: 2, symbol: "SDR", symbolPosition: "before" },
  XOF: { code: "XOF", name: "West African CFA Franc", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "Fr", symbolPosition: "before" },
  XPD: { code: "XPD", name: "Palladium", isoFractionDigits: null, displayFractionDigits: 2, symbol: "oz t", symbolPosition: "before" },
  XPF: { code: "XPF", name: "CFP Franc", isoFractionDigits: 0, displayFractionDigits: 0, symbol: "₣", symbolPosition: "before" },
  XPT: { code: "XPT", name: "Platinum", isoFractionDigits: null, displayFractionDigits: 2, symbol: "oz t", symbolPosition: "before" },
  YER: { code: "YER", name: "Yemeni Rial", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "﷼", symbolPosition: "before" },
  ZAR: { code: "ZAR", name: "South African Rand", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "R", symbolPosition: "before" },
  ZMW: { code: "ZMW", name: "Zambian Kwacha", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "K", symbolPosition: "before" },
  ZWG: { code: "ZWG", name: "Zimbabwe Gold", isoFractionDigits: 2, displayFractionDigits: 2, symbol: "ZiG", symbolPosition: "before" },
}
